/* istanbul ignore file */

export default {
    ALARM_CLOCK: 'ALARM_CLOCK',
    FILLING_HOUSE: 'FILLING_HOUSE',
    SLP_VIEWED_HOUSE: 'SLP_VIEWED_HOUSE',
    STAR: 'STAR',
    TICK_CALENDAR: 'TICK_CALENDAR',
    VIEWED_HOUSE: 'VIEWED_HOUSE',
    INFO: 'INFO',
    WARN: 'WARN',
    DELAY_REFUND: 'DELAY_REFUND'
};
